<template>
  <v-container fluid style="width: 100%; padding: 0" class="fontscolor">
    <Header />

    <article class="mobile-center">
      <section class="fw-section">
        <div style="background-color: #edf4fe">
          <div class="container fullwidthsec">
            <div class="row" style="padding-top: 50px">
              <div class="page-title title-size-normal text-dark"></div>
            </div>

            <div class="container fullwidthsec">
              <strong
                ><font size="5" style="font-size: 19pt"
                  >PRIVACY NOTICE</font
                ></strong
              >
              <p>
                <strong
                  ><font color="#7f7f7f"
                    ><font size="3" style="font-size: 11pt"
                      >Last updated 2025-09-03
                    </font></font
                  ></strong
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >Thank you for choosing to be part of our community at
                    (“</font
                  ></font
                ><strong
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt">Company</font></font
                  ></strong
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt">”, “</font></font
                ><strong
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt">we</font></font
                  ></strong
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt">”, “</font></font
                ><strong
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt">us</font></font
                  ></strong
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt">”, or “</font></font
                ><strong
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt">our</font></font
                  ></strong
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >”). We are committed to protecting your personal
                    information and your right to privacy. If you have any
                    questions or concerns about our notice, or our practices
                    with regards to your personal information, please contact us
                    at .</font
                  ></font
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >When you visit our website maposcope.com, use mobile
                    application Maposcope, and use our services, you trust us
                    with your personal information. We take your privacy very
                    seriously. In this privacy notice, we seek to explain to you
                    in the clearest way possible what information we collect,
                    how we use it and what rights you have in relation to it. We
                    hope you take some time to read through it carefully, as it
                    is important. If there are any terms in this privacy notice
                    that you do not agree with, please discontinue use of our
                    Apps and our services.</font
                  ></font
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >This privacy notice applies to all information collected
                    through our mobile application, (&quot;</font
                  ></font
                ><strong
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt">Apps</font></font
                  ></strong
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >&quot;), and/or any related services, sales, marketing or
                    events (we refer to them collectively in this privacy notice
                    as the &quot;</font
                  ></font
                ><strong
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >Services</font
                    ></font
                  ></strong
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt">&quot;).</font></font
                >
              </p>
              <p>
                <strong
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >Please read this privacy notice carefully as it will help
                      you make informed decisions about sharing your personal
                      information with us.</font
                    ></font
                  ></strong
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >TABLE OF CONTENTS</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <a href="#infocollect"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >1. WHAT INFORMATION DO WE COLLECT?</font
                    ></font
                  ></a
                ><font size="3" style="font-size: 11pt"> </font>
              </p>
              <p>
                <a href="#infoshare"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >2. WILL YOUR INFORMATION BE SHARED WITH ANYONE?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#cookies"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >3. DO WE USE COOKIES AND OTHER TRACKING
                      TECHNOLOGIES?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#googlemaps"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >4. DO WE USE GOOGLE MAPS?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#inforetain"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >5. HOW LONG DO WE KEEP YOUR INFORMATION?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#infosafe"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >6. HOW DO WE KEEP YOUR INFORMATION SAFE?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#infominors"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >7. DO WE COLLECT INFORMATION FROM MINORS?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#privacyrights"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >8. WHAT ARE YOUR PRIVACY RIGHTS?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#DNT"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >9. CONTROLS FOR DO-NOT-TRACK FEATURES</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#caresidents"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY
                      RIGHTS?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#policyupdates"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >11. DO WE MAKE UPDATES TO THIS POLICY?</font
                    ></font
                  ></a
                >
              </p>
              <p>
                <a href="#contact"
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >12. HOW CAN YOU CONTACT US ABOUT THIS POLICY?</font
                    ></font
                  ></a
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="infocollect"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >1. WHAT INFORMATION DO WE COLLECT?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><font size="3" style="font-size: 11pt"><br /> </font></strong
                ><strong
                  ><font size="3" style="font-size: 12pt"
                    >Information automatically collected</font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >Some information — such as IP address and/or browser and
                      device characteristics — is collected automatically when
                      you visit our Apps.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >We automatically collect certain information when you
                    visit, use or navigate the Apps. This information does not
                    reveal your specific identity (like your name or contact
                    information) but may include device and usage information,
                    such as your IP address, browser and device characteristics,
                    operating system, language preferences, referring URLs,
                    device name, country, location, information about how and
                    when you use our Apps and other technical information. This
                    information is primarily needed to maintain the security and
                    operation of our Apps, and for our internal analytics and
                    reporting purposes.</font
                  ></font
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >Like many businesses, we also collect information through
                    cookies and similar technologies.
                  </font></font
                >
              </p>
              <p>
                <strong
                  ><font size="3" style="font-size: 12pt"
                    ><br />
                    Information collected through our Apps</font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >We may collect information regarding your geo-location,
                      mobile device, push notifications, when you use our
                      apps.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >If you use our Apps, we may also collect the following
                    information:</font
                  ></font
                >
              </p>
              <ul>
                <li>
                  <p>
                    <em
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Geo-Location Information.</font
                        ></font
                      ></em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may request access or permission to and track
                        location-based information from your mobile device,
                        either continuously or while you are using our mobile
                        application, to provide location-based services. If you
                        wish to change our access or permissions, you may do so
                        in your device's settings.
                      </font></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <em
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Mobile Device Access.</font
                        ></font
                      ></em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may request access or permission to certain features
                        from your mobile device, including your mobile device's
                        , and other features. If you wish to change our access
                        or permissions, you may do so in your device's
                        settings.</font
                      ></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <em
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Mobile Device Data.</font
                        ></font
                      ></em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may automatically collect device information (such as
                        your mobile device ID, model and manufacturer),
                        operating system, version information and IP
                        address.</font
                      ></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <em
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Push Notifications.</font
                        ></font
                      ></em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may request to send you push notifications regarding
                        your account or the mobile application. If you wish to
                        opt-out from receiving these types of communications,
                        you may turn them off in your device's settings.</font
                      ></font
                    >
                  </p>
                </li>
              </ul>

              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="infoshare"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >2. WILL YOUR INFORMATION BE SHARED WITH ANYONE?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >We only share information with your consent, to comply
                      with laws, to provide you with services, to protect your
                      rights, or to fulfill business obligations.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >We may process or share data based on the following legal
                    basis:</font
                  ></font
                >
              </p>
              <ul>
                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Consent:</font
                        ></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may process your data if you have given us specific
                        consent to use your personal information in a specific
                        purpose.</font
                      ></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Legitimate Interests:</font
                        ></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may process your data when it is reasonably necessary
                        to achieve our legitimate business interests.</font
                      ></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Performance of a Contract:
                        </font></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >Where we have entered into a contract with you, we may
                        process your personal information to fulfill the terms
                        of our contract.</font
                      ></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Legal Obligations:</font
                        ></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may disclose your information where we are legally
                        required to do so in order to comply with applicable
                        law, governmental requests, a judicial proceeding, court
                        order, or legal process, such as in response to a court
                        order or a subpoena (including in response to public
                        authorities to meet national security or law enforcement
                        requirements).</font
                      ></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Vital Interests:</font
                        ></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may disclose your information where we believe it is
                        necessary to investigate, prevent, or take action
                        regarding potential violations of our policies,
                        suspected fraud, situations involving potential threats
                        to the safety of any person and illegal activities, or
                        as evidence in litigation in which we are
                        involved.</font
                      ></font
                    >
                  </p>
                </li>
              </ul>

              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >More specifically, we may need to process your data or
                    share your personal information in the following
                    situations:</font
                  ></font
                >
              </p>
              <ul>
                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Vendors, Consultants and Other Third-Party Service
                          Providers.</font
                        ></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may share your data with third party vendors, service
                        providers, contractors or agents who perform services
                        for us or on our behalf and require access to such
                        information to do that work. Examples include: payment
                        processing, data analysis, email delivery, hosting
                        services, customer service and marketing efforts. We may
                        allow selected third parties to use tracking technology
                        on the Apps, which will enable them to collect data
                        about how you interact with the Apps over time. This
                        information may be used to, among other things, analyze
                        and track data, determine the popularity of certain
                        content and better understand online activity. Unless
                        described in this Policy, we do not share, sell, rent or
                        trade any of your information with third parties for
                        their promotional purposes.
                      </font></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Business Transfers.</font
                        ></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may share or transfer your information in connection
                        with, or during negotiations of, any merger, sale of
                        company assets, financing, or acquisition of all or a
                        portion of our business to another company.</font
                      ></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Third-Party Advertisers.</font
                        ></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may use third-party advertising companies to serve
                        ads when you visit the Apps. These companies may use
                        information about your visits to our Website(s) and
                        other websites that are contained in web cookies and
                        other tracking technologies in order to provide
                        advertisements about goods and services of interest to
                        you.
                      </font></font
                    >
                  </p>
                </li>

                <li>
                  <p>
                    <strong
                      ><font color="#595959"
                        ><font size="3" style="font-size: 11pt"
                          >Business Partners.</font
                        ></font
                      ></strong
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt">
                        We may share your information with our business partners
                        to offer you certain products, services or
                        promotions.</font
                      ></font
                    >
                  </p>
                </li>
              </ul>

              <p>
                <br />
                <br />
              </p>
              <p>
                <a name="cookies"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >3. DO WE USE COOKIES AND OTHER TRACKING
                      TECHNOLOGIES?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >We may use cookies and other tracking technologies to
                      collect and store your information.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >We may use cookies and similar tracking technologies (like
                    web beacons and pixels) to access or store information.
                    Specific information about how we use such technologies and
                    how you can refuse certain cookies is set out in our Cookie
                    Policy.</font
                  ></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="googlemaps"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >4. DO WE USE GOOGLE MAPS?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >Yes, we use Google Maps for the purpose of providing
                      better service.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >This website, mobile application, or Facebook application
                    uses Google Maps APIs. You may find the Google Maps APIs
                    Terms of Service
                  </font></font
                ><a
                  href="https://developers.google.com/maps/terms"
                  target="_blank"
                  ><font color="#3030f1"
                    ><font size="3" style="font-size: 11pt">here</font></font
                  ></a
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >. To better understand Google’s Privacy Policy, please
                    refer to this
                  </font></font
                ><a href="https://policies.google.com/privacy" target="_blank"
                  ><font color="#3030f1"
                    ><font size="3" style="font-size: 11pt">link</font></font
                  ></a
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt">.</font></font
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >By using our Maps API Implementation, you agree to be bound
                    by Google’s Terms of Service. You agree to allow us to
                    obtain or cache your location. You may revoke your consent
                    at anytime.
                  </font></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="inforetain"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >5. HOW LONG DO WE KEEP YOUR INFORMATION?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >We keep your information for as long as necessary to
                      fulfill the purposes outlined in this privacy notice
                      unless otherwise required by law.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >We will only keep your personal information for as long as
                    it is necessary for the purposes set out in this privacy
                    notice, unless a longer retention period is required or
                    permitted by law (such as tax, accounting or other legal
                    requirements).</font
                  ></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="infosafe"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >6. HOW DO WE KEEP YOUR INFORMATION SAFE?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >We aim to protect your personal information through a
                      system of organizational and technical security
                      measures.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >We have implemented appropriate technical and
                    organizational security measures designed to protect the
                    security of any personal information we process. However,
                    please also remember that we cannot guarantee that the
                    internet itself is 100% secure. Although we will do our best
                    to protect your personal information, transmission of
                    personal information to and from our Apps is at your own
                    risk. You should only access the services within a secure
                    environment.</font
                  ></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="infominors"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >7. DO WE COLLECT INFORMATION FROM MINORS?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >We do not knowingly collect data from or market to
                      children under 18 years of age.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >We do not knowingly solicit data from or market to children
                    under 18 years of age. By using the Apps, you represent that
                    you are at least 18 or that you are the parent or guardian
                    of such a minor and consent to such minor dependent’s use of
                    the Apps. If we learn that personal information from users
                    less than 18 years of age has been collected, we will
                    deactivate the account and take reasonable measures to
                    promptly delete such data from our records. If you become
                    aware of any data we have collected from children under age
                    18, please contact us at .</font
                  ></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="privacyrights"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >8. WHAT ARE YOUR PRIVACY RIGHTS?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >In some regions, such as the European Economic Area, you
                      have rights that allow you greater access to and control
                      over your personal information. You may review, change, or
                      terminate your account at any time.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >In some regions (like the European Economic Area), you have
                    certain rights under applicable data protection laws. These
                    may include the right (i) to request access and obtain a
                    copy of your personal information, (ii) to request
                    rectification or erasure; (iii) to restrict the processing
                    of your personal information; and (iv) if applicable, to
                    data portability. In certain circumstances, you may also
                    have the right to object to the processing of your personal
                    information. To make such a request, please use the</font
                  ></font
                ><font size="3" style="font-size: 11pt"> </font
                ><a href="#contact"
                  ><font color="#3030f1"
                    ><font size="3" style="font-size: 11pt"
                      >contact details</font
                    ></font
                  ></a
                ><font color="#595959"
                  ><font size="3" style="font-size: 11pt">
                    provided below. We will consider and act upon any request in
                    accordance with applicable data protection laws.</font
                  ></font
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >If we are relying on your consent to process your personal
                    information, you have the right to withdraw your consent at
                    any time. Please note however that this will not affect the
                    lawfulness of the processing before its withdrawal.</font
                  ></font
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >If you are resident in the European Economic Area and you
                    believe we are unlawfully processing your personal
                    information, you also have the right to complain to your
                    local data protection supervisory authority. You can find
                    their contact details here:</font
                  ></font
                ><font size="3" style="font-size: 11pt"> </font
                ><font color="#3030f1"
                  ><font size="3" style="font-size: 11pt"
                    ><a
                      href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm"
                      target="_blank"
                      >http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a
                    >.</font
                  ></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="DNT"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >9. CONTROLS FOR DO-NOT-TRACK FEATURES</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >Most web browsers and some mobile operating systems and
                    mobile applications include a Do-Not-Track (“DNT”) feature
                    or setting you can activate to signal your privacy
                    preference not to have data about your online browsing
                    activities monitored and collected. No uniform technology
                    standard for recognizing and implementing DNT signals has
                    been finalized. As such, we do not currently respond to DNT
                    browser signals or any other mechanism that automatically
                    communicates your choice not to be tracked online. If a
                    standard for online tracking is adopted that we must follow
                    in the future, we will inform you about that practice in a
                    revised version of this privacy notice.</font
                  ></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="caresidents"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY
                      RIGHTS?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >Yes, if you are a resident of California, you are granted
                      specific rights regarding access to your personal
                      information.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >California Civil Code Section 1798.83, also known as the
                    “Shine The Light” law, permits our users who are California
                    residents to request and obtain from us, once a year and
                    free of charge, information about categories of personal
                    information (if any) we disclosed to third parties for
                    direct marketing purposes and the names and addresses of all
                    third parties with which we shared personal information in
                    the immediately preceding calendar year. If you are a
                    California resident and would like to make such a request,
                    please submit your request in writing to us using the
                    contact information provided below.</font
                  ></font
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >If you are under 18 years of age, reside in California, and
                    have a registered account with the Apps, you have the right
                    to request removal of unwanted data that you publicly post
                    on the Apps. To request removal of such data, please contact
                    us using the contact information provided below, and include
                    the email address associated with your account and a
                    statement that you reside in California. We will make sure
                    the data is not publicly displayed on the Apps, but please
                    be aware that the data may not be completely or
                    comprehensively removed from our systems.</font
                  ></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p style="line-height: 150%">
                <a name="policyupdates"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >11. DO WE MAKE UPDATES TO THIS POLICY?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <strong
                  ><em
                    ><font color="#595959"
                      ><font size="3" style="font-size: 11pt"
                        >In Short:
                      </font></font
                    ></em
                  ></strong
                ><em
                  ><font color="#595959"
                    ><font size="3" style="font-size: 11pt"
                      >Yes, we will update this policy as necessary to stay
                      compliant with relevant laws.</font
                    ></font
                  ></em
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >We may update this privacy notice from time to time. The
                    updated version will be indicated by an updated “Revised”
                    date and the updated version will be effective as soon as it
                    is accessible. If we make material changes to this privacy
                    notice, we may notify you either by prominently posting a
                    notice of such changes or by directly sending you a
                    notification. We encourage you to review this privacy notice
                    frequently to be informed of how we are protecting your
                    information.</font
                  ></font
                >
              </p>
              <p style="line-height: 150%">
                <br />
                <br />
              </p>
              <p>
                <a name="contact"></a
                ><strong
                  ><font color="#000000"
                    ><font size="4" style="font-size: 14pt"
                      >12. HOW CAN YOU CONTACT US ABOUT THIS POLICY?</font
                    ></font
                  ></strong
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >If you have questions or comments about this policy, you
                    may email us at or by post to:</font
                  ></font
                >
              </p>
              <p>
                <font color="#595959"
                  ><font size="3" style="font-size: 11pt"
                    >Maposcope Marcin Wider</font
                  >
                  <br />
                  support @ maposcope . com<br />
                  43-300 Bielsko-Biała<br />
                  Leśna 25B<br />
                  Poland<br />
                </font>
              </p>
              <p style="line-height: 150%">
                <a name="contact1"></a><br />
                <br />
              </p>
              <p>
                <a name="contact2"></a
                ><font size="3" style="font-size: 11pt"
                  >If you are a resident in the European Economic Area, the
                  &quot;data controller&quot; of your personal information is
                  Marcin Wider to be its representative in the EEA. You can
                  contact them directly regarding the processing of your
                  information by dingsda by email at support @ maposcope . com
                  or by post to: the address above.
                </font>
              </p>
              <p style="margin-bottom: 0in; line-height: 100%"><br /></p>
            </div>
          </div>
        </div>
      </section>
    </article>

    <Footer />
    <vue-cookies-consent
      backgroundButton="#1972f5"
      borderRadius="5"
      backgroundButtonHover="#3A4F52"
      offsetY="5"
      style="z-index: 1000"
    >
      <template #description>
        <p>
          We use cookies to ensure you get the best experience on our website
          <router-link to="privacy-policy"
            ><span style="color: #0a64eb">Read more</span></router-link
          >
        </p>
      </template>
      <template #button>Accept cookies</template>
    </vue-cookies-consent>
  </v-container>
</template>

<script>
import VueCookiesConsent from "@norvikit/vue-cookies-consent";
export default {
  components: {
    VueCookiesConsent,
  },
};
</script>


<style scoped>
a {
  color: red;
}
.error-msg {
  color: red;
  font-weight: bold;
}

.wlink a,
a:active,
a:hover {
  color: #2c405a !important;
}
.v-application a {
  color: #2c405a !important;
}

.btnl1 {
  color: #ffffff !important;
  background-color: #1972f5;
}

.btnl1:hover {
  background-color: #0a64eb;
}

.btnl2 {
  color: #ffffff !important;
  background-color: #eceff6;
}

.btnl2:hover {
  background-color: #eceff6;
}
.fullwidthsec {
  max-width: 1200px;
}

ul li::before {
  content: "";
}

ul li {
  content: "";
}
</style>